import { render, staticRenderFns } from "./BookPromo.vue?vue&type=template&id=30c8511a&scoped=true"
import script from "./BookPromo.vue?vue&type=script&lang=js"
export * from "./BookPromo.vue?vue&type=script&lang=js"
import style0 from "./BookPromo.vue?vue&type=style&index=0&id=30c8511a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c8511a",
  null
  
)

export default component.exports